<template>
  <div class="flex flex-col h-screen bg-gray-50">
    <div class="sticky top-0 z-50">
      <van-nav-bar title="比赛报名" left-text="返回" left-arrow @click-left="onClickLeft" class="custom-nav-bar" />
    </div>

    <div class="flex-1 overflow-auto p-16">
      <div class="flex justify-between items-center mb-16 p-16 bg-white rounded-lg shadow-md">
        <h1 class="text-xl font-semibold text-gray-800">{{ matchSubjectName }}</h1>
        <van-button class="bg-gradient-to-r from-primary to-primary-dark border-0 shadow-md" icon="user-o"
          type="primary" size="small" @click="signupForOther">
          为他人报名
        </van-button>
      </div>

      <van-form @submit="onSubmit">
        <van-cell-group inset class="bg-white rounded-lg shadow-md overflow-hidden mb-16">
          <van-field v-model="signupInfo.name" label="姓名" placeholder="请输入用户名" :required="true" />
          <van-field v-model="signupInfo.mobilePhone" type="tel" label="手机" placeholder="请输入手机号" :required="true" />
          <van-field label="性别" :required="true">
            <template #input>
              <van-radio-group v-model="gender" direction="horizontal">
                <van-radio name="0">男</van-radio>
                <van-radio name="1">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <van-field v-model="signupInfo.birthDate" readonly clickable label="生日" placeholder="请选择生日" :required="true"
            @click="showBirthDatePicker = true" />

          <van-field label="左右手" :required="true">
            <template #input>
              <van-radio-group v-model="leftRightHand" direction="horizontal">
                <van-radio name="0">右手</van-radio>
                <van-radio name="1">左手</van-radio>
                <van-radio name="2">双手</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <van-field label="打球类型" :required="true">
            <template #input>
              <van-radio-group v-model="matchBowlerKickType" direction="horizontal">
                <van-radio name="0">直线</van-radio>
                <van-radio name="1">曲线</van-radio>
                <van-radio name="2">飞碟</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>

        <div class="p-16">
          <div class="flex gap-4 justify-between">
            <van-button round block type="primary"
              class="flex-1 h-48 text-lg font-medium bg-gradient-to-r from-primary to-primary-dark border-0 shadow-md"
              native-type="submit">
              确认报名
            </van-button>
            <van-button round block type="default"
              class="flex-1 h-48 text-lg font-medium bg-white border border-gray-300 text-gray-600 shadow-sm"
              @click="$router.back()">
              取消
            </van-button>
          </div>
        </div>

      </van-form>

      <!-- 日期选择器弹出层 -->
      <van-popup v-model:show="showBirthDatePicker" position="bottom" class="date-picker-popup" :round="true">
        <van-date-picker v-model="currentDate" title="选择生日" type="date" :min-date="new Date(1940, 0, 1)"
          :max-date="new Date()" @confirm="onConfirmBirthDate" @cancel="showBirthDatePicker = false" />
      </van-popup>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { onMounted } from 'vue';
import msApi from '../../api/match'
import { matchSignUp } from '../../api/index.js'
import util from "../../global/util.js";
import { Toast } from "@vant/compat";
import { useRoute } from 'vue-router'
import router from '@/router/index.js';
import store from '@/store/index.js';
import logger from '@/global/logger.js';
import enums from '@/api/enums.js';
import user from '@/global/user';
import bowler from '@/api/user.js';

let route = useRoute()
const matchSubjectId = ref('');
const isCountDownShow = ref(false);
const matchSubjectName = ref('');
const matchId = ref('');
const isEditMode = ref(true);
const showBirthDatePicker = ref(false);

const signupInfo = ref({
  bowlerId: '',
  matchId: '',
  name: '',
  leftRightHand: 0,
  matchBowlerKickType: 0,
  gender: 0,
  mobilePhone: '',
  age: null,
  matchSubjectId: '',
  avatar: null,
  name: '用户名',
  birthDate: ''
});

const currentDate = ref([]);
const gender = ref('');
const leftRightHand = ref('');
const matchBowlerKickType = ref('');

onMounted(async () => {
  let id = route.query.id;
  if (util.isBlank(id)) {
    Toast.fail('获取比赛信息失败')
    return;
  }
  let matchSubjectInfo = await msApi.getMatchSubjectBasicInfo(id);
  if (util.isBlank(matchSubjectInfo)) {
    Toast.fail('获取比赛信息失败')
    return;
  }
  else {
    matchSubjectId.value = matchSubjectInfo.id;
    matchSubjectName.value = matchSubjectInfo.name;
    signupInfo.value.matchSubjectId = matchSubjectInfo.id;
    signupInfo.value.matchSubjectName = matchSubjectInfo.name;
    signupInfo.value.matchId = matchSubjectInfo.matchId;

    await user.checkAuth("请先登录，再进行报名操作。");
    await fetchBowlerInfo();
  }
});

const fetchBowlerInfo = async () => {
  try {
    let bowlerInfo = await bowler.getMyBowlerInfo();
    signupInfo.value.name = bowlerInfo.name;
    signupInfo.value.mobilePhone = bowlerInfo.mobilePhone;
    signupInfo.value.birthDate = util.formatDate(bowlerInfo.birthDate);
    signupInfo.value.gender = bowlerInfo.gender;
    signupInfo.value.leftRightHand = bowlerInfo.leftRightHand;
    signupInfo.value.matchBowlerKickType = bowlerInfo.matchBowlerKickType;
    signupInfo.value.bowlerId = bowlerInfo.id;

    if (signupInfo.value.birthDate) {
      signupInfo.value.birthDate = util.formatDate(signupInfo.value.birthDate);
      currentDate.value = util.formatDateArray(signupInfo.value.birthDate)
    }

    if (!util.isBlank(bowlerInfo.gender)) {
      gender.value = bowlerInfo.gender.toString();
    }
    if (!util.isBlank(bowlerInfo.leftRightHand)) {
      leftRightHand.value = bowlerInfo.leftRightHand.toString();
    }
    if (!util.isBlank(bowlerInfo.matchBowlerKickType)) {
      matchBowlerKickType.value = bowlerInfo.matchBowlerKickType.toString();
    }
    logger.debug(bowlerInfo.value);
  }
  catch (error) {
    Toast.fail('获取用户信息失败,' + error);
  }
};

const onClickLeft = () => {
  router.push('/')
}

const onSubmit = async (values) => {
  signupInfo.value.gender = parseInt(gender.value);
  signupInfo.value.leftRightHand = parseInt(leftRightHand.value);
  signupInfo.value.matchBowlerKickType = parseInt(matchBowlerKickType.value);
  //alert(signupInfo.value);
  var ret = await msApi.applyInMatchSubject(signupInfo.value);
  if (util.isBlank(ret)) {
    Toast.fail('报名失败')
    return;
  } else {
    Toast.success('报名成功')
    router.push('/');
  }
};

const onConfirmBirthDate = (value) => {
  let vDate = util.formatDate(currentDate.value);
  signupInfo.value.birthDate = vDate;
  showBirthDatePicker.value = false;
}

const signupForOther = (value) => {
  signupInfo.value.bowlerId = null;
  signupInfo.value.name = '';
  signupInfo.value.leftRightHand = 0;
  leftRightHand.value = '';
  signupInfo.value.matchBowlerKickType = 0;
  matchBowlerKickType.value = '';
  signupInfo.value.gender = 0;
  gender.value = '';
  signupInfo.value.mobilePhone = '';
  signupInfo.value.name = '';
  signupInfo.value.birthDate = '';
};

const sendSmsCode = () => {
  if (userphone.value == '') {
    return;
  }
  console.log(userphone.value)
  var regex = /^1\d{10}$/
  if (regex.test(userphone.value)) {
    // 在这里调用API发送验证码
    // 发送成功后开始倒计时
    this.isCountDownShow = true;
  }
};
</script>

<style scoped>
.container {
  position: relative;
  height: 100vh;
  background-color: #f5f7fa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}


.fixed-header {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.content-section {
  padding: 0.427rem;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* 增加 iOS 滚动惯性 */
}

.info-card {
  background: white;
  border-radius: 0.427rem;
  margin-bottom: 0.427rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.van-field) {
  padding: 0.427rem 0.533rem;
}

:deep(.van-field__label) {
  color: #2c3e50;
  font-weight: 500;
  width: 4em;
}

:deep(.van-radio-group) {
  display: flex;
  gap: 0.533rem;
}

:deep(.van-radio__label) {
  color: #2c3e50;
}

:deep(.van-radio__icon .van-icon) {
  border-color: #3498db;
}

:deep(.van-radio__icon--checked .van-icon) {
  background-color: #3498db;
  border-color: #3498db;
}

.button-section {
  padding: 0.427rem;
  margin-top: 0.427rem;
}

.action-button {
  height: 1.173rem;
  font-size: 0.4rem;
  background: linear-gradient(135deg, #3498db, #2980b9);
  border: none;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
}

:deep(.action-button.van-button--primary:active) {
  background: linear-gradient(135deg, #2980b9, #2472a4);
}

/* 日期选择器弹出层样式 */
.date-picker-popup {
  border-radius: 0.427rem 0.427rem 0 0;
}

:deep(.van-picker__toolbar) {
  border-bottom: 1px solid #ebedf0;
}

:deep(.van-picker__title) {
  color: #2c3e50;
  font-weight: 600;
}

:deep(.van-picker__confirm) {
  color: #3498db;
}

:deep(.van-picker__cancel) {
  color: #95a5a6;
}

:deep(.van-picker-column__item--selected) {
  color: #3498db;
  font-weight: 500;
}
</style>